
import styles from "@/styles/featuredSection.module.scss"
import { Image, Skeleton, Spin, Empty } from 'antd';
import GoodsComponentWithDiscountNew from "@/components/GoodsComponentWithDiscountNew"
import featuredSectionApi from '@/service/modules/featuredSectionApi'
import { useEffect, useState } from "react";
import SwiperSelf from '@/components/SwiperSelf'
import FilterBar from '@/components/FilterBar'
import { SwiperSlide } from 'swiper/react';
import InfiniteScroll from 'react-infinite-scroll-component';
import SliderBarRight from "@/components/SliderBarRight"
import SliderBarLeft from "@/components/SliderBarLeft"
import GoogleADSense from "@/components/GoogleADSense"
import GoodsComponent from "@/components/GoodsComponent";
import { getQueryParam } from "@/utils/utils";
import { fillterBarDictionary } from "@/utils/dictionary"
import Script from "next/script";
interface Props {
  type: string;
  defaultSort?: object
}

interface DAMNU_ENABLE {
  [key: string]: any, // 字段扩展声明
}

export default function FeaturedSection({ type, defaultSort }: Props) {
  const topSeller = "top-seller"
  const weeklyDeals = "weekly-deals"
  const [weeklyDealsTitle, setWeeklyDealsTitle] = useState('')
  const [topList, setTopList] = useState([])
  const [recommendCategory, setRecommendCategory] = useState<number | string>("")
  const [recommendCategoryList, setRecommendCategoryList] = useState([])
  const [featuredSectionList, setFeaturedSectionList] = useState([])
  const [loading, setLoading] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)
  const [pageSize] = useState(20)
  const [total, setTotal] = useState(0)
  const [filterBarData, setFilterBarData] = useState<DAMNU_ENABLE>({})
  const [isFinsh, setIsFinsh] = useState(false)
  const [isEmpty, setIsEmpty] = useState(false)
  const [aboutDetail, setAboutDetail] = useState<any>({})

  const resultName: DAMNU_ENABLE = {
    'top-seller': "Hottest Deals",
    'clearance': "Clearance",
    'new-arrival': "New Arrivals",
    'free-shipping': "Free Shipping",
    'weekly-deals': "weeklydeals"
  }

  const [bannerImg, setBannerImg] = useState<DAMNU_ENABLE>({
    'top-seller': "",
    'clearance': "",
    'new-arrival': "",
    'free-shipping': "",
    'weekly-deals': ""
  })

  // 追踪是否已经进行了第一次数据请求带pid
  const [initialDataFetched, setInitialDataFetched] = useState(false);

  useEffect(() => {
    if (type !== weeklyDeals) {
      getTopList()
      getRecommendCategory()
      getAboutDetail()
    }
  }, [])

  useEffect(() => {
    getFeaturedSectionList()
  }, [recommendCategory, currentPage, pageSize, filterBarData])

  useEffect(() => {
    getBanner()
  }, [])

  // 获取banner图
  const getBanner = async () => {
    try {
      const res = await featuredSectionApi.getFullBanner(type)
      const obj = res.data
      for (const key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          const element = obj[key];
          setBannerImg({ [type]: element.subBannerImgUrl })
          setWeeklyDealsTitle(element.title)
        }
      }
    } catch (error) {
      console.log(error);
    }
  }

  // 获取top5商品
  const getTopList = async () => {
    try {
      const res = await featuredSectionApi.mooncakeBox(type)
      const list = res.data.map((v: any) => { return { ...v, productName: v.name, imgUrl: v.filename } })
      setTopList(list)
    } catch (error) {
      console.log(error);
    }
  }

  // 获取分类
  const getRecommendCategory = async () => {
    try {
      const res = await featuredSectionApi.getRecommendCategory(type)
      setRecommendCategoryList(res.data);
    } catch (error) {
      console.log(error);
    }
  }

  // 选择分类（顶部）
  const selectRecommendCategory = (categoryID: string | number) => {
    setFeaturedSectionList([])
    setCurrentPage(1)
    setIsFinsh(false)
    recommendCategory === categoryID ? setRecommendCategory("") : setRecommendCategory(categoryID)

    // 需要删除掉分类为brands的
    let data = filterBarData
    const dictionary = fillterBarDictionary.dictionary
    for (const key in dictionary) {
      if (Object.prototype.hasOwnProperty.call(dictionary, key)) {
        const element = dictionary[key];
        if (element === 3) {
          delete data[key]
        }
      }
    }
    setFilterBarData(data)
  }

  const onSlideChange = (event: any) => {
    console.log(event);
  }

  // const pageOnChange = (page: number, pageSize: number) => {
  //   setCurrentPage(page)
  //   setPageSize(pageSize)
  // }

  // 左侧筛选处理
  const filterBarChange = (item: any) => {
    let data = filterBarData

    // 重复选需要删除
    if (JSON.stringify(data[item.key]) == JSON.stringify(item)) {
      delete data[item.key]
    } else {
      // Price Range与Hot Brands是相互冲突的
      if (fillterBarDictionary.getValueByKey(item.key) != 1) {
        for (const key in data) {
          if (Object.prototype.hasOwnProperty.call(data, key)) {
            // 判断不为custom-filtering的都互斥
            fillterBarDictionary.getValueByKey(key) != 1 && delete data[key]
          }
        }
      }
      data = { ...filterBarData, [item.key]: item }
    }

    // hot-brand需要去掉上面的筛选
    if (fillterBarDictionary.getValueByKey(item.key) === 3) {
      setRecommendCategory("")
    }

    setFeaturedSectionList([])
    setCurrentPage(1)
    setIsFinsh(false)
    setFilterBarData({ ...data })
  }

  const getFeaturedSectionList = async () => {
    try {
      setLoading(true)
      let params: any = {
        categoryID: recommendCategory,
        page: currentPage,
        perPage: pageSize,
        ...defaultSort
      }

      if (!initialDataFetched) {
        const pid = getQueryParam("pid")
        if (pid) {
          params.productID = pid
        }
        setInitialDataFetched(true)
      }
      // 遍历左侧对象
      for (const key in filterBarData) {
        if (Object.prototype.hasOwnProperty.call(filterBarData, key)) {
          const element = filterBarData[key];

          // 判断属于哪个类目下，传参有所不同
          if (fillterBarDictionary.getValueByKey(element.key) === 1) {
            params.sortBy = element.sortBy
            params.sortDirection = element.direction
          }
          if (fillterBarDictionary.getValueByKey(element.key) === 2) {
            params.minPrice = element.minPrice
            params.maxPrice = element.maxPrice
          }
          if (fillterBarDictionary.getValueByKey(element.key) === 3) {
            params.brand = element.name
          }
          if (fillterBarDictionary.getValueByKey(element.key) === 4) {
            params.categoryID = element.categoryID
          }
        }
      }
      const res = await featuredSectionApi.getSectionList(type, params)

      let pageList = { items: [], total: 0 }

      // 周推数据结构不一致
      if (type === weeklyDeals) {
        const { weeklySales } = res.data
        pageList = { ...weeklySales.pageList, total: weeklySales.pageList.items.length }
        setIsFinsh(true)

        // 周推topList处理
        const list = weeklySales.dailyProductList.map((v: any) => {
          // productName、imgUrl字段兼容组件
          return { ...v, productName: v.name, imgUrl: v.filename ? v.filename : "" }
        })
        setTopList(list)
      } else {
        pageList = res.data.pageList
        setIsFinsh(pageList.items.length < pageSize)
      }

      let list: any = []
      if (pageList.items && pageList.items.length) {
        list = pageList.items.map((v: any) => {
          const obj = {
            ...v,
            productName: v.name,
            imgUrl: v.filename ? v.filename : ""
          }
          return obj
        })
      }
      setTotal(pageList.total)
      setFeaturedSectionList(featuredSectionList.concat(list))
      setLoading(false)
      setIsEmpty(pageList.items.length == 0)

    } catch (error) {
      setIsFinsh(true)
      setLoading(false)
    }
  }

  const getAboutDetail = async () => {
    try {
      const res = await featuredSectionApi.getAboutDetail(type)
      console.log(res);
      setAboutDetail(res.data)
    } catch (error) {
      console.log(error);
    }
  }

  const handleScroll = () => {

    const targetElement = document.getElementById("product-list-id")

    if (targetElement) {
      // 获取目标元素的位置信息
      const targetElementRect = targetElement.getBoundingClientRect();

      // 获取窗口的滚动位置
      const scrollPosition = window.scrollY || window.pageYOffset;

      // 判断窗口是否已经移动到目标元素底部
      if (scrollPosition + window.innerHeight >= targetElementRect.bottom + scrollPosition) {
        // 在这里触发加载事件
        if (!loading && !isFinsh) {
          window.scrollBy(0, -100); // 向上滚动一点，避免触底状态持续
          setCurrentPage(currentPage + 1)
        }
      }
    }
  };

  let itemUrl = ''
  switch (type) {
    case "clearance":
      itemUrl = "https://www.bestdeals.co.nz/clearance";
      break;
    case "free-shipping":
      itemUrl = "https://www.bestdeals.co.nz/free-shipping";
      break;
    case "new-arrival":
      itemUrl = "https://www.bestdeals.co.nz/newarrival";
      break;
    case "top-seller":
      itemUrl = "https://www.bestdeals.co.nz/topsellernew";
      break;
    case "weekly-deals":
      itemUrl = "https://www.bestdeals.co.nz/weeklydeals";
      break;
  }
  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": "https://www.bestdeals.co.nz/"
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": type === weeklyDeals ? "Weekly Deals" : type,
        "item": itemUrl
      }
    ]
  };

  return (
    <>
      <div className={`${styles['featuredSection-box']} slider-wapper`}>
        <SliderBarLeft></SliderBarLeft>
        <SliderBarRight></SliderBarRight>
        {
          type === weeklyDeals
          &&
          <div className={styles['class-subject']}>{weeklyDealsTitle}</div>
        }
        <div className={styles['top-banner']}>
          {
            bannerImg[type]
            &&
            <Image
              width="100%"
              src={bannerImg[type]}
              preview={false}
              alt="banner"
            />
          }
        </div>
        {
          type === weeklyDeals
          &&
          <div className={styles['class-subject']} style={{ marginTop: "24px", textAlign: "center" }}>Trending Products</div>
        }
        <div className={styles['top-five-product']}>
          {
            topList.length > 0
              ?
              topList.map((item: any, index: number) => (
                <div className={styles['product-item']} key={item.productID}>
                  <GoodsComponentWithDiscountNew {...item} hiddenTags={true} hiddenDiscount={true} showLeval={type === weeklyDeals || type === topSeller} leval={index + 1} />
                </div>
              ))
              :
              <Skeleton active />
          }
        </div>

        {/* 周推不予展示 */}
        {
          type !== weeklyDeals
          &&
          <div className={styles['recommend-category']}>
            <div className={styles['title']}>Recommend for you</div>
            <div className={styles['category-list']}>
              <SwiperSelf
                slidesPerView={7}
                slideChange={onSlideChange}
                autoplay={false}
              >
                {
                  recommendCategoryList.length > 0
                    ?
                    recommendCategoryList.map((item: any) => (
                      <SwiperSlide key={item.categoryID}>
                        <div
                          className={`${styles['categoryItem']} ${recommendCategory == item.categoryID && styles['active']}`}
                          onClick={() => { selectRecommendCategory(item.categoryID) }}
                        >
                          <div className={styles['category']}>
                            <div className={styles['category_img']}>
                              <Image src={item.icon} preview={false} alt="category_img" />
                            </div>
                          </div>
                          <p className={styles['categoryName']}>{item.name}</p>
                        </div>
                      </SwiperSlide>
                    ))
                    :
                    <Skeleton active />
                }
              </SwiperSelf>
            </div>
          </div>
        }


        <div className={styles['categories']}>
          <div className={styles['left']}>
            <FilterBar type={type} onChange={filterBarChange} filterBarData={filterBarData} />
          </div>
          <div className={styles['right']}>
            <div className={styles['list-title']}>
              <span className={styles['red']}>{total}</span> Results for&nbsp;
              <span className={styles['red']}>
                {
                  Object.keys(filterBarData).length > 0
                    ?
                    Object.entries(filterBarData).map(([key, value]: any) => {
                      let name = ""
                      // custom-filtering需要特殊处理
                      if (fillterBarDictionary.getValueByKey(key) === 1) {
                        name = `${value.name}${value.description ? `(${value.description})` : ''}`
                      } else {
                        name = value.name
                      }
                      return name
                    }).join(",")
                    :
                    <>{resultName[type]}</>
                }
              </span>
            </div>
            <InfiniteScroll
              dataLength={featuredSectionList.length}
              next={() => { }}
              hasMore={!isFinsh}
              onScroll={handleScroll}
              endMessage={
                <>
                  {/* {
                  !isEmpty
                  &&
                  <p style={{ textAlign: 'center' }}>
                    <b>Yay! You have seen it all</b>
                  </p>
                } */}
                </>
              }
              loader={
                <>
                  {
                    loading
                    &&
                    <p style={{ textAlign: 'center' }}>
                      loading...
                    </p>
                  }
                </>
              }
            >
              <Spin spinning={false} size="large">
                <div className={styles['product-list']} id="product-list-id" style={{ minHeight: "200px" }}>
                  {
                    featuredSectionList.length > 0
                      ?
                      featuredSectionList.map((item: any, index: number) => (
                        <div className={styles['product-list-item']} key={item.productID}>
                          {
                            type === weeklyDeals
                              ?
                              <GoodsComponent {...item} position={index} location={weeklyDeals} type='CrazyDeal' />
                              :
                              <GoodsComponentWithDiscountNew {...item} />
                          }
                        </div>
                      ))
                      :
                      <>
                        {
                          (isEmpty && !loading)
                            ?
                            <Empty style={{ 'flexBasis': '100%' }} />
                            :
                            <Skeleton active />
                        }
                      </>
                  }
                  <div className={styles['product-list-item']}></div>
                  <div className={styles['product-list-item']}></div>
                  <div className={styles['product-list-item']}></div>

                </div>
                {/* <Pagination
              current={currentPage}
              pageSize={pageSize}
              total={total}
              onChange={pageOnChange}
            /> */}
              </Spin>
            </InfiniteScroll>

            {
              type !== weeklyDeals
              &&
              <div className={styles['about-featured']}>
                <div className={styles['about-featured-title']}>{aboutDetail.name}</div>
                <div className={styles['about-featured-content']} dangerouslySetInnerHTML={{ __html: aboutDetail.description }}></div>
              </div>
            }

            <GoogleADSense />
          </div>
        </div>
      </div>

      <Script
        type="application/ld+json"
        id="breadcrumb-schema"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }}
      />
    </>
  )
}